"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _InnerPopupWrapperStyled = require("../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _Button = _interopRequireDefault(require("../../Button"));
var _reactI18next = require("react-i18next");
var _popupSlice = require("../../../redux/popupSlice");
var _UpdatePaymentDetailsPopupStyled = require("../UpdatePaymentDetailsPopupStyled");
var _jsxRuntime = require("react/jsx-runtime");
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M93.648 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M99.956 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M96.016 3.096a.761.761 0 0 1-.762-.762V.762A.761.761 0 0 1 96.016 0a.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M96.016 9.405a.761.761 0 0 1-.762-.762V7.071a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "m4.437 65.45-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "m8.898 69.91-1.112-1.112a.762.762 0 0 1 0-1.077.762.762 0 0 1 1.078 0l1.111 1.111a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.077 0Z",
                        fill: "#cb4477"
                      })
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M7.784 65.45a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L8.862 65.45a.762.762 0 0 1-1.078 0Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M3.323 69.91a.762.762 0 0 1 0-1.077l1.112-1.111a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.077L4.4 69.911a.762.762 0 0 1-1.078 0Z",
                        fill: "#cb4477"
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M9.471 5.838a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M9.471 6.838c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
                  fill: "#cb4477"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M96.471 59.838a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M96.471 60.838c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
                  fill: "#cb4477"
                })]
              })]
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(31 11.838)",
          fill: "#cb4477",
          stroke: "#cb4477",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M44.767 35.584c-3.008-6.169-8.049-14.92-12.5-22.64-2.327-4.041-4.526-7.856-6.115-10.756a4 4 0 0 0-7.129 0c-1.59 2.9-3.79 6.721-6.12 10.764C8.458 20.667 3.418 29.417.412 35.584A4.012 4.012 0 0 0 0 37.35a4.054 4.054 0 0 0 4.035 4.064h37.108a4.054 4.054 0 0 0 4.035-4.064 4.011 4.011 0 0 0-.411-1.766Zm-3.623 3.948H4.037a2.171 2.171 0 0 1-2.153-2.182 2.14 2.14 0 0 1 .221-.941c2.978-6.109 8-14.826 12.431-22.517 2.335-4.053 4.54-7.881 6.139-10.8a2.18 2.18 0 0 1 3.827 0c1.6 2.917 3.8 6.742 6.135 10.791 4.433 7.693 9.457 16.414 12.436 22.525a2.135 2.135 0 0 1 .222.942 2.171 2.171 0 0 1-2.151 2.182Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M22.589 9.413a.941.941 0 0 0-.941.941v18.824a.941.941 0 1 0 1.883 0V10.354a.941.941 0 0 0-.942-.941Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            cx: ".941",
            cy: ".941",
            r: ".941",
            transform: "translate(21.648 33.884)"
          })]
        })
      })]
    })
  });
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100.718",
  height: "73.237"
};
const ErrorStep = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    error
  } = (0, _reactRedux.useSelector)(state => state.finalizeAddPaymentDetails);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_UpdatePaymentDetailsPopupStyled.ImageWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WarningIcon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
        children: t('oops-something-went-wrong', 'Oops! Something went wrong.')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
        children: error !== null && error !== void 0 && error.includes('Refused') ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
          i18nKey: "update-payment-details-popup.refused",
          children: ["We weren\u2019t able to update your payment method. ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), " Please try again."]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
          i18nKey: "update-payment-details-popup.error",
          children: ["We weren\u2019t able to update your payment details. ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), " Please try again using different payment method."]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      $removeMargin: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "simple",
        onClickFn: () => dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
          step: _popupSlice.PAYMENT_DETAILS_STEPS.PAYMENT_DETAILS_UPDATE,
          isLoading: false
        })),
        children: t('update-payment-details-popup.try-again', 'Try again')
      })
    })]
  });
};
var _default = exports.default = ErrorStep;